<template>
    <AxRoadPage
        :title="$t('ax_road.warnings')"
        :closable="$route.name === 'axRoadWarnings'"
        class="warnings-view"
    >
        <div class="warnings-view__controls l-inline">
            <AxRoadButton
                v-for="filter in filters"
                :key="filter.value"
                :variant="type === filter.value ? 'dark' : 'outline'"
                @click="handleFilterClick(filter.value)"
            >
                {{ filter.label }}
            </AxRoadButton>
        </div>
        <div v-if="filteredItems.length">
            <AxRoadWarningsListItem
                v-for="item in filteredItems"
                :key="item.id"
                :item="item"
            />
        </div>
        <div v-else-if="isWarningsFetching" class="l-padded-y">
            <VSpinner size="medium" line-fg-color="#000" :speed="1" />
        </div>
        <div v-else class="l-inline l-center l-padded-y">
            {{ $t('no_warnings') }}
        </div>
    </AxRoadPage>
</template>

<script>
import AxRoadPage from '@/components/ax-road/AxRoadPage.vue'
import { mapGetters, mapState } from 'vuex'
import AxRoadWarningsListItem from '@/components/ax-road/AxRoadWarningsListItem.vue'
import AxRoadButton from '@/components/ax-road/AxRoadButton.vue'
import VSpinner from 'vue-simple-spinner'

export default {
    name: 'WarningsView',
    components: {
        VSpinner,
        AxRoadButton,
        AxRoadWarningsListItem,
        AxRoadPage,
    },
    data() {
        return {
            type: '',
            filters: [
                {
                    label: this.$t('all'),
                    value: 'all',
                },
                {
                    label: this.$t('driver'),
                    value: 'driver',
                },
                {
                    label: this.$t('truck'),
                    value: 'truck',
                },
            ],
        }
    },
    computed: {
        ...mapState('tracker', ['drivers', 'trackers']),
        ...mapState('warnings', ['warnings', 'isWarningsFetching']),
        ...mapGetters('warnings', ['driverWarningsMap', 'assetWarningsMap']),
        filteredItems() {
            const items = [...this.drivers, ...this.trackers]
                .map(item => ({
                    ...item,
                    name: item.asset_details?.name || item.name,
                    type: item.asset_details ? 'truck' : 'driver',
                    warnings: (item.asset_details
                        ? this.assetWarningsMap[item.asset_details.id] || []
                        : this.driverWarningsMap[item.id] || []
                    ).filter(warning => !warning.resolved),
                }))
                .filter(item => item.warnings.length > 0)
                .sort((a, b) => b.warnings.length - a.warnings.length)

            if (this.type === 'all') {
                return items
            }
            return items.filter(item => item.type === this.type)
        },
    },
    watch: {
        '$route.query.type'(newType) {
            if (this.type !== newType) {
                this.type = newType
            }
        },
    },
    created() {
        this.type = this.$route.query.type || 'all'
    },
    methods: {
        handleFilterClick(value) {
            this.$router.push({ query: { type: value } })
        },
    },
}
</script>

<i18n>
{
    "en": {
        "all": "All",
        "driver": "Driver",
        "truck": "Truck",
        "no_warnings": "No warnings"
    },
    "de": {
        "all": "Alle",
        "driver": "Fahrer",
        "truck": "Fahrzeug",
        "no_warnings": "Keine Warnungen"
    },
    "fr": {
        "all": "Tous",
        "driver": "Conducteur",
        "truck": "Camion",
        "no_warnings": "Aucun avertissement"
    },
    "it": {
        "all": "Tutti",
        "driver": "Autista",
        "truck": "Camion",
        "no_warnings": "Nessun avviso"
    }
}
</i18n>

<style lang="scss" scoped>
.warnings-view {
    &__controls {
        gap: 12px;
        padding-bottom: 12px;
        border-bottom: $style-border;
    }
    &__sort-icon {
        transition: all 0.1s ease-in-out;
        &--asc {
            transform: scaleY(-1);
        }
    }
}
</style>
